import logo from './logo.svg';
import './App.css';
import Home from './Home';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <Home/>
      <div className="Joke-footer">
        <h4>Made with 💜 by <a href='https://github.com/varshitha1707'>Vee</a></h4>
        <h6>© Feb' 2022 Chuckl</h6>
      </div>
      </header>
    </div>
  );
}

export default App;
